import { useEffect, useState } from "react";
import {useNavigate } from "react-router-dom";
import { siteRoutes } from "utils/helpers/enums/routes";

import { EventsFilterDTO } from "utils/helpers/models/host-dtos/events-filter.dto";
import { EventDTO } from "utils/helpers/models/shared/event.dto";
import EventCard from "components/cards/event-card";
import { useSelector } from "react-redux";
import DataNotFound from "components/data-not-found";
import useAmbassador from "containers/ambassador/useHooks";
import AmbassadorBreadcrumb, { AmbassadorBreadcrumbLink } from "components/breadcrumbs/AmbassadorBreadcrumb";
import useUtils from "hooks/useUtils";
import CustomMessageDisplay from "components/data-not-found/CustomMessageDisplay";
import eventNotFoundGif from "assets/images/gifs/event-not-found.gif"; 

const AmbassadorJoinExperiences = () => {
  const breadcrumbLinks: AmbassadorBreadcrumbLink[] = [
    { title: "Home", path: siteRoutes.ambassadorHome },
    {
      title: "Experiences",
      path: siteRoutes.ambassadorJoinEvents,
    },
  ];

  const navigate = useNavigate();
 const { getQueryParams } = useUtils()
  const query = getQueryParams()
  
  // const { getEvents } = useHost();
  const { getJoinAbleEvents} = useAmbassador()
  const [data, setData] = useState<EventDTO[]>([]);
  const { isLoading } = useSelector((state: any) => state.sharedReducer);
  const followBtn = false

  const [filters, setFilters] = useState<EventsFilterDTO>(() => {
    const defaultFilters = new EventsFilterDTO();
    return defaultFilters;
  });

  const getAllEvents = (filters: EventsFilterDTO) => {
    const queryParams: any = {};
    for (let key in filters) {
      if (filters[key]?.toString()) queryParams[key] = filters[key];
    }
    getJoinAbleEvents(setData);

  };

  useEffect(() => {
    getAllEvents(filters);
  }, []);

  const goToExpDetail = (id: number) => {
    navigate(`${siteRoutes.experienceDetail}?id=${id}`);
  };

  const handlePageChange = (pageInfo: { selected: number; limit: number }) => {
    filters.page = pageInfo.selected;
    filters.size = pageInfo.limit;
    getAllEvents(filters);
  };
  


  return (
    <div className="container min-h-screen mb-10">
      <AmbassadorBreadcrumb links={breadcrumbLinks} />
      <h2 className="text-2xl font-bold mb-4 mt-6">Experiences</h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-6">
        {data.map((event, index) => (
          <EventCard event={event} key={index} followBtn={followBtn} shareEvent={query?.shareEvent} />
        ))}
      </div>

      {/* <Pagination
        count={filters.totalElements}
        page={filters.page}
        limit={filters.size}
        onPageChange={handlePageChange}
        activeBgColor={"#DE9C27"}
        activeTextColor={"#ffffff"}
      /> */}

      <div className="mt-10">
      <CustomMessageDisplay
        show={!isLoading && !data.length }
        title="No Badges Available"
        slogan="You don't have any badges yet. Complete achievements to earn badges!"
        image={eventNotFoundGif}
        imageAlt="No badges found"
        className="py-12"
        imageClassName="w-[150px] h-[120px]"
        titleClassName="text-2xl font-bold text-blackie"
        sloganClassName="text-gray-500 text-base"
      />
      </div>
    </div>
  );
};

export default AmbassadorJoinExperiences;
